import React, { useContext } from "react"
import PropTypes from "prop-types"
import AuthContext from "context/auth/authContext"
import { getCurrency } from "utils/functions"
import { partPropType } from "../CertHistoryPropTypes"
import CertHistoryRowContentTableHead from "./CertHistoryRowContentTableHead"
import CertHistoryRowContentRow from "./CertHistoryRowContentRow"

const CertHistoryRowContent = ({
  data,
  isInvoicing = false,
  selectedParts,
  invoicingDrafts,
  onToggleSelectedPart,
  onUpdateInvoicingDraft,
  onPersistInvoicingAmount,
  onOpenMeasuresDialog,
  numberPrefix = "",
}) => {
  const { user } = useContext(AuthContext)
  const currencySymbol = getCurrency(user["custom:currency"])
  const parts = Array.isArray(data) ? data : []

  return (
    <div className="mt-2 mb-2 backgroundWhite" style={{ overflowX: "auto" }}>
      <table className="tablaPartidas">
        <CertHistoryRowContentTableHead
          currencySymbol={currencySymbol}
          isInvoicing={isInvoicing}
        />
        <tbody>
          {parts.length > 0
            ? parts.map((part, index) => (
                <CertHistoryRowContentRow
                  key={part.partidaId}
                  part={part}
                  index={index}
                  numberPrefix={numberPrefix}
                  isInvoicing={isInvoicing}
                  selectedParts={selectedParts}
                  invoicingDrafts={invoicingDrafts}
                  onToggleSelectedPart={onToggleSelectedPart}
                  onUpdateInvoicingDraft={onUpdateInvoicingDraft}
                  onPersistInvoicingAmount={onPersistInvoicingAmount}
                  onOpenMeasuresDialog={onOpenMeasuresDialog}
                />
              ))
            : null}
        </tbody>
      </table>
    </div>
  )
}

CertHistoryRowContent.propTypes = {
  data: PropTypes.arrayOf(partPropType),
  isInvoicing: PropTypes.bool,
  selectedParts: PropTypes.object.isRequired,
  invoicingDrafts: PropTypes.object.isRequired,
  onToggleSelectedPart: PropTypes.func.isRequired,
  onUpdateInvoicingDraft: PropTypes.func.isRequired,
  onPersistInvoicingAmount: PropTypes.func.isRequired,
  onOpenMeasuresDialog: PropTypes.func,
  numberPrefix: PropTypes.string,
}

export default CertHistoryRowContent
